(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pth-26d-conversion"] && !Shopify.designMode) return;
  try {
    
  (()=>{const root=document.querySelector('[data-p26d]');if(!root)return;const main=root.querySelector('.p26d-main-image');root.querySelectorAll('[data-p26d-thumb]').forEach(button=>button.addEventListener('click',()=>{if(!main)return;main.src=button.dataset.src;main.alt=button.dataset.alt||'';root.querySelectorAll('[data-p26d-thumb]').forEach(item=>item.classList.remove('is-active'));button.classList.add('is-active')}))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pth-282b-conversion"] && !Shopify.designMode) return;
  try {
    
  (()=>{const root=document.querySelector('[data-p282]');if(!root)return;const quantities=root.querySelectorAll('input[name="quantity"]');const total=root.querySelector('[data-p282-total]');const count=root.querySelector('[data-p282-count]');const unit=root.querySelector('[data-p282-unit]');const saving=root.querySelector('[data-p282-saving]');const returnTo=root.querySelector('[data-p282-return]');const updatePack=()=>{const option=root.querySelector('input[name="quantity"]:checked');if(!option)return;total.textContent=option.dataset.total;count.textContent=option.value+(option.value==='1'?' device total':' devices total');unit.textContent=(Number(option.value)>=3?'Approx. ':'')+option.dataset.unit+' per device';saving.textContent=option.dataset.saving||'';returnTo.value=option.value==='4'?'/discount/P282B4SAVE15?redirect='+encodeURIComponent(returnTo.dataset.cartUrl):returnTo.dataset.cartUrl};quantities.forEach(option=>option.addEventListener('change',updatePack));updatePack();const main=root.querySelector('.p282-main-image');root.querySelectorAll('[data-p282-thumb]').forEach(button=>button.addEventListener('click',()=>{if(!main)return;main.srcset=button.dataset.srcset||'';main.sizes=button.dataset.sizes||'(max-width: 900px) 100vw, 52vw';main.src=button.dataset.src;main.alt=button.dataset.alt||'';root.querySelectorAll('[data-p282-thumb]').forEach(item=>item.classList.remove('is-active'));button.classList.add('is-active')}))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pth-co-series-conversion"] && !Shopify.designMode) return;
  try {
    
  (()=>{const root=document.querySelector('[data-pcs]');if(!root)return;const main=root.querySelector('.pcs-main-image');root.querySelectorAll('[data-pcs-thumb]').forEach(button=>button.addEventListener('click',()=>{if(!main)return;main.srcset=button.dataset.srcset||'';main.sizes=button.dataset.sizes||'(max-width: 900px) 100vw, 52vw';main.src=button.dataset.src;main.alt=button.dataset.alt||'';root.querySelectorAll('[data-pcs-thumb]').forEach(item=>item.classList.remove('is-active'));button.classList.add('is-active')}))})();

  } catch(e) { console.error(e); }
})();
})();
